<template>
  <body>
    <div class="container">
      <div class="yellow"></div>
      <div class="red"></div>
      <div class="blue"></div>
      <div class="violet"></div>
    </div>
  </body>
</template>

<script>
export default {

}
</script>

<style scoped>
body {
	margin: 0;
	display: flex;
	justify-content: center;
	align-items: center;
}
div.container {
	display: flex;
	justify-content: space-between;
}
div > div {
	width: 1rem;
	height: 1rem;
	border-radius: 100%;
	margin: 1rem;
	background-image: linear-gradient(145deg, rgba(255,255,255,0.5) 0%, rgba(0,0,0,0) 100%);
	animation: bounce 0.8s 0.2s linear infinite;
}
.yellow {
	background-color: #feb60a;
}

.red {
	background-color: #ff0062;
	animation-delay: 0.1s;
}

.blue {
	background-color: #00dbf9;
	animation-delay: 0.2s;
}

.violet {
	background-color:#da00f7;
	animation-delay: 0.3s;
}

@keyframes bounce {
	0%, 50%, 100% {
		transform: scale(1);
		filter: blur(0px);
	}
	25% {
		transform: scale(0.8);
		filter: blur(1px);
	}
	75% {
		filter: blur(1px);
		transform: scale(1.2);
	}
}
</style>